import React from "react";
import "./emailNotificationSwitch.scss";

/**
 * Toggle matching the Two Factor Authentication modal switch.
 */
export default function EmailNotificationSwitch({
  checked = true,
  onChange,
  disabled = false,
  label = "Send Email Notification",
}) {
  return (
    <div className="email-notification-switch">
      <span className="email-notification-switch__label">{label}</span>
      <button
        type="button"
        role="switch"
        aria-checked={checked}
        aria-label={label}
        className={`email-notification-switch__control${checked ? " is-on" : ""}`}
        onClick={() => {
          if (disabled) return;
          onChange?.(!checked);
        }}
        disabled={disabled}
      >
        <span className="email-notification-switch__thumb" />
      </button>
    </div>
  );
}
